var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9132 10.0926L2.02182 10.0926C1.73566 10.0926 1.48203 9.98201 1.26091 9.7609C1.03979 9.53978 0.929236 9.28614 0.929236 8.99999C0.929236 8.71384 1.03979 8.46021 1.26091 8.23909C1.48203 8.01797 1.73566 7.90741 2.02182 7.90741L15.9132 7.90741L9.98204 1.97626C9.76093 1.75514 9.65037 1.49501 9.65037 1.19585C9.65037 0.896688 9.76093 0.63655 9.98204 0.415432C10.2032 0.194315 10.4633 0.083756 10.7625 0.083756C11.0616 0.083756 11.3218 0.194315 11.5429 0.415432L19.347 8.21958C19.5681 8.4407 19.6787 8.70083 19.6787 8.99999C19.6787 9.29915 19.5681 9.55929 19.347 9.78041L11.5429 17.5846C11.3218 17.8057 11.0616 17.9162 10.7625 17.9162C10.4633 17.9162 10.2032 17.8057 9.98204 17.5846C9.76093 17.3634 9.65037 17.1033 9.65037 16.8041C9.65037 16.505 9.76093 16.2448 9.98204 16.0237L15.9132 10.0926Z",
    fill: "#168004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.bbd4189b1bd2af0d3a54311dd5418830.svg";
export { ForwardRef as ReactComponent };